import styled from 'styled-components'
import { ArrowRightIcon } from '@velasca/icons/arrow-right'
import { CheckIcon } from '@velasca/icons/check'
import { CloseIcon } from '@velasca/icons/close'
import { LoadingIcon } from '@velasca/icons/loading'

export const Container = styled.div<{ condensedLayout?: boolean }>`
  ${({ condensedLayout }) => condensedLayout && 'width: 100%;'};
  position: relative;
  display: flex;
  align-self: end;
`

export const Button = styled.button<{
  success: boolean
  condensedLayout?: boolean
}>`
  display: flex;
  align-items: center;
  gap: ${({ condensedLayout }) => (condensedLayout ? '3rem' : '8rem')};
  ${({ condensedLayout }) =>
    condensedLayout && 'width: 100%; justify-content: space-between;'}
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.4rem;
  line-height: 1.25;
  letter-spacing: 0;
  font-weight: 500;
  text-transform: uppercase;
  padding: 1.25rem 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  background-color: ${({ theme, success }) =>
    success ? theme.colors.primary : theme.colors.background};

  color: ${({ theme, success }) =>
    success ? theme.colors.text.secondary : theme.colors.text.primary};

  &:disabled {
    cursor: default;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary} !important;
    outline-offset: 2px !important;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary} !important;
    outline-offset: 2px !important;
  }

  &:focus:not(:focus-visible) {
    outline: none !important;
  }
`

export const IconCaret = styled(ArrowRightIcon)`
  width: 1rem;
  height: 1rem;
  transform: rotate(90deg);
`

export const IconEmpty = styled.div`
  width: 1rem;
  height: 1rem;
`

export const IconLoading = styled(LoadingIcon)`
  width: 1rem;
  height: 1rem;
  g {
    fill: ${({ theme }) => theme.colors.text.primary};
  }
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const IconSuccess = styled(CheckIcon)`
  width: 1rem;
  height: 1rem;
`

export const IconError = styled(CloseIcon)`
  width: 1rem;
  height: 1rem;
`

export const Dropdown = styled.div<{ opened: boolean }>`
  display: ${({ opened }) => (opened ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 157px;
  z-index: 1700;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  transform: translateZ(0);
  overflow-y: auto;

  scrollbar-color: ${({ theme }) => theme.colors.hover}
    ${({ theme }) => theme.colors.background};
  scrollbar-width: thin;
`

export const DropdownItem = styled.div<{ isOutOfStock?: boolean }>`
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-family: ${({ theme }) => theme.fonts.brand};
    font-size: 1.4rem;
    line-height: 1.25;
    letter-spacing: 0;
    font-weight: 500;
    text-transform: uppercase;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary} !important;
    outline-offset: -2px !important;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary} !important;
    outline-offset: -2px !important;
  }

  &:focus:not(:focus-visible) {
    outline: none !important;
  }

  ${({ isOutOfStock, theme }) =>
    isOutOfStock &&
    `
    color: ${theme.colors.text.light};
    cursor: not-allowed;

    &:hover {
      background-color: transparent;
    }
  `}
`
